import Controller from './Controller';
import type Report from '../checks/Report';
import { Combined_CreateDependency } from '../commands/combined';
import type { DependencyType } from '../commands/types';

/**
 * Controller for adding a dependency
 */
export default class AddDependencyController extends Controller {
  async addDependency(
    masterId: string,
    dependentId: string,
    type: DependencyType
  ): Promise<Report> {
    return this.executeAndCheck(model => {
      const { checks } = Combined_CreateDependency(
        model,
        masterId,
        dependentId,
        type,
        this.modelVersion.model.propagateOnDependency
      );
      return checks;
    });
  }
}
